/* Subscriptions page modules (sections/elysian-plans.liquid), round 2, 2026-09-30.
   1. Gift listed totals: each length tile's price follows the chosen coffee and size (data-ely-gift-price, keyed "coffee line|size").
   2. Wired modules: keeps the form's hidden variant id and selling_plan in step with the choices. The map (data-ely-cart-map) is keyed
      "coffee line|size|grind|length" in lower case, empty where the product has no such option; each entry is {v: variant id,
      p: {weeks: selling plan id}} (gift: weeks "0"). Liquid fills the defaults, so without this file the default choice still adds.
      A combination with no variant or plan disables the button rather than adding the wrong bag. */
(function () {
  if (window.elySubsCartBound) return;
  window.elySubsCartBound = true;

  function lc(s) { return (s || '').trim().toLowerCase(); }
  function picked(mod, attr) {
    var el = mod.querySelector('[' + attr + ']:checked');
    return el ? lc(el.getAttribute(attr)) : '';
  }

  function bind(mod) {
    if (mod.hasAttribute('data-ely-cart-bound')) return;
    mod.setAttribute('data-ely-cart-bound', '');
    var gift = mod.hasAttribute('data-ely-gift');
    var prices = [];
    Array.prototype.forEach.call(mod.querySelectorAll('[data-ely-gift-price]'), function (el) {
      try { prices.push({ el: el, map: JSON.parse(el.getAttribute('data-ely-gift-price')) }); } catch (e) {}
    });
    var map = null;
    var mapEl = mod.querySelector('[data-ely-cart-map]');
    if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (e) { map = null; } }
    var idIn = mod.querySelector('[data-ely-cart-id]');
    var planIn = mod.querySelector('[data-ely-cart-plan]');
    var btn = mod.querySelector('[data-ely-cart-submit]');

    function sync() {
      var c = mod.querySelector('[data-ely-sub-coffee]:checked');
      var ci = c ? c.value : '1';
      var size = picked(mod, 'data-ely-cart-sz');
      if (gift) {
        prices.forEach(function (p) {
          var v = p.map[ci + '|' + size];
          if (v && p.el.textContent !== v) p.el.textContent = v;
        });
      }
      if (!map || !idIn || !planIn || !btn) return;
      var tile = picked(mod, 'data-ely-cart-tile');
      var grind = picked(mod, 'data-ely-cart-g');
      var key = gift ? ci + '|' + size + '|' + grind + '|' + tile : ci + '|' + tile + '|' + grind + '|';
      var weeks = gift ? '0' : (picked(mod, 'data-ely-cart-weeks') || '0');
      var entry = map[key];
      var plan = entry && entry.p ? entry.p[weeks] : null;
      if (entry) idIn.value = entry.v;
      if (plan) planIn.value = plan;
      btn.disabled = !(entry && plan);
    }
    mod.addEventListener('change', sync);
    sync();
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ely-sub]'), bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
